var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.CoauthorTag = function (superClass) {
  extend(CoauthorTag, superClass);
  function CoauthorTag() {
    return CoauthorTag.__super__.constructor.apply(this, arguments);
  }
  CoauthorTag.fromUserSearch = function (coauthor, options) {
    if (options == null) {
      options = {};
    }
    return new Works.CoauthorTag({
      name: coauthor.get('name'),
      email: coauthor.get('email'),
      encrypted_email: coauthor.get('encrypted_email'),
      affiliation: coauthor.get('university'),
      tagged_user_id: coauthor.get('id'),
      source: coauthor.get('source') || (options != null ? options.source : void 0),
      source_details: coauthor.get('source_details') || {
        name: 'search',
        email: 'search'
      }
    }, options);
  };
  CoauthorTag.prototype.initialize = function (attributes) {
    if (attributes) {
      CoauthorTag.__super__.initialize.call(this, _.omit(attributes, 'display_name', 'coauthor_email'));
      if (attributes.display_name) {
        this.set('name', attributes.display_name);
      }
      if (attributes.coauthor_email) {
        this.set('email', attributes.coauthor_email);
      }
      return this.set('orig_email', this.get('email'));
    }
  };
  CoauthorTag.prototype.validate = function (attrs) {
    var errors;
    errors = {};
    if (!this._validateNamePresence(attrs)) {
      errors['name'] = "You must provide your co-author's name.";
    }
    if (!this._validateNameLength(attrs)) {
      errors['name'] || (errors['name'] = "Your co-author's name can't be longer than 240 characters.");
    }
    if (!this._validateEmailPresence(attrs)) {
      errors['email'] = "To tag your co-author, you must provide their email.";
    }
    if (!this._validateEmailFormat(attrs)) {
      errors['email'] || (errors['email'] = "Your co-author's email appears to be invalid.");
    }
    if (_.size(errors) > 0) {
      return errors;
    }
  };
  CoauthorTag.prototype._validateNamePresence = function (attrs) {
    return attrs.name && attrs.name.length > 0;
  };
  CoauthorTag.prototype._validateNameLength = function (attrs) {
    return attrs.name && attrs.name.length < 240;
  };
  CoauthorTag.prototype._validateEmailPresence = function (attrs) {
    return attrs.email && attrs.email.length > 0;
  };
  CoauthorTag.prototype._validateEmailFormat = function (attrs) {
    if (attrs.email === this.get('orig_email')) {
      return true;
    } else {
      return attrs.email && $h.validEmail(attrs.email, {
        strict: true
      });
    }
  };
  CoauthorTag.prototype.save = function (attrs, options) {
    var ref;
    if (options == null) {
      options = {};
    }
    options.url || (options.url = (ref = this.collection) != null ? ref.url() : void 0);
    if (this.has('work_id')) {
      options.url || (options.url = $r.api_v0_work_co_author_tags_path({
        subdomain_param: 'api',
        work_id: this.get('work_id')
      }));
    }
    return CoauthorTag.__super__.save.call(this, attrs, options);
  };
  CoauthorTag.prototype.rejectAsSuggestion = function () {
    if (!this.has('work_id')) {
      return;
    }
    return $.post(this.suggestionUrl(), {
      work_id: this.get('work_id'),
      tagged_user_id: this.get('tagged_user_id'),
      name: this.get('name'),
      email: this.get('email'),
      encrypted_email: this.get('encrypted_email'),
      source: this.get('source'),
      source_details: this.get('source_details'),
      accepted: false
    });
  };
  CoauthorTag.prototype.url = function () {
    return $r.api_v0_work_co_author_tag_path({
      id: this.get('id'),
      work_id: this.get('work_id'),
      subdomain_param: 'api'
    });
  };
  CoauthorTag.prototype.suggestionUrl = function () {
    return $r.api_v0_suggestions_coauthors_path({
      subdomain_param: 'api'
    });
  };
  CoauthorTag.prototype.uniqueEmail = function () {
    return this.get('encrypted_email') || this.get('email');
  };
  return CoauthorTag;
}(Backbone.Model);
window.extend = extend;
window.hasProp = hasProp;